import { useQuery } from "@tanstack/react-query";
import { TrustPilotUtils } from "@/shared/components/TrustPilotCarousel/TrustPilotUtils";
import { PublicConfig } from "@/shared/PublicConfig";

export const useTrustPilot = (underwriter: string, tag?: string) => {
    const isValidUnderwriter = underwriter && underwriter in PublicConfig.TRUSTPILOT_CONFIG;

    const queryResult = useQuery({
        queryKey: ["trustPilotData", underwriter, tag ?? "default"],
        queryFn: () => TrustPilotUtils.getData(underwriter, tag)
    });

    if (!isValidUnderwriter) {
        return { data: null, isLoading: false, error: "Invalid or undefined underwriter" };
    }

    return queryResult;
};
